export default function htmlToText(
  str?: string | null,
  options?: {
    isTrim?: boolean
    isCollapseWhitespace?: boolean
  }
): string {
  if (!str) return ''

  const div = document.createElement('div')

  div.innerHTML = str

  let text = div.innerText

  if (options?.isCollapseWhitespace) {
    text = text.replace(/\s+/g, ' ')
  }

  if (options?.isTrim) {
    text = text.trim()
  }

  return !text &&
    !options?.isTrim &&
    div.querySelectorAll('ul, ol, li').length > 1
    ? ' '
    : text
}
